import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Theme, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: Theme) => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '80px'
  },
  image: {
    width: '80px',
    height: '80px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(3)
  },
  title: {
    fontWeight: 700
  }
}));

interface HeaderProps {
  children: any;
  title: string;
  bgColor: string;
}

const Header = ({ title, children, bgColor }: HeaderProps) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} component="header" className={classes.headerContainer}>
      <div style={{ backgroundColor: bgColor }} className={classes.image}>
        {children}
      </div>
      <Typography className={classes.title} variant="h5" component="h1">
        {title}
      </Typography>
    </Grid>
  );
};

export default Header;
